import { render } from "./GridParteneri.vue?vue&type=template&id=07c28e32&ts=true"
import script from "./GridParteneri.vue?vue&type=script&lang=ts"
export * from "./GridParteneri.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__